/* eslint-disable react-hooks/exhaustive-deps */
import { API_ROOT } from '../common';
import { CONSOLIDATION_API } from '@/module/corporate-consolidation-report/constants';
import CRConsolidationReportPDF from '@/new-components/CRConsolidationReportPDF';
import customToast from '@/new-components/CustomNotification';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const CRConsolidationReportViewerDownload = (props) => {
  const accessToken = useSelector((state) => state.auth.accessToken);
  const { pdfDocConsolidation } = useSelector((state) => state.globalState);
  const [consolidationData, setConsolidationData] = useState(
    props.consolidationDataOverride !== undefined
      ? props.consolidationDataOverride
      : null
  );

  useEffect(() => {
    if (props.consolidationDataOverride !== undefined) return;
    if (!props.projectId || !(props.accessToken || accessToken)) return;
    fetch(
      `${API_ROOT}${CONSOLIDATION_API.data}/${
        props.projectId
      }?type=${encodeURIComponent('Consolidated')}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${props.accessToken || accessToken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (get(res, 'statusCode') === 200) {
          setConsolidationData(res?.data);
        } else {
          customToast(
            'error',
            res?.message || 'Failed to load consolidation report'
          );
          if (props.resetData) props.resetData();
        }
      })
      .catch(() => {
        customToast('error', 'Failed to load consolidation report');
        if (props.resetData) props.resetData();
      });
  }, [props.projectId, props.accessToken, accessToken]);

  useEffect(() => {
    if (
      !pdfDocConsolidation ||
      !props.downloading ||
      Object.keys(props.downloading).length === 0
    )
      return;
    const projectCode =
      consolidationData?.projectInfo?.projectCode || 'consolidation';
    const blob = pdfDocConsolidation
      .setProperties({
        title: 'CR Consolidation Report',
      })
      .output('blob', {
        filename: `CR_Consolidation_Report_${projectCode}.pdf`,
      });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `CR_Consolidation_Report_${projectCode}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    if (props.resetData) props.resetData();
  }, [
    pdfDocConsolidation,
    consolidationData,
    props.downloading,
    props.resetData,
  ]);

  return (
    <Container>
      <LinkContainer>
        <CRConsolidationReportPDF
          consolidationData={consolidationData}
          pdfStoreKey="pdfDocConsolidation"
        />
      </LinkContainer>
    </Container>
  );
};

export default CRConsolidationReportViewerDownload;

const Container = styled.div`
  display: flex;
  align-items: center;
  visibility: hidden;
  height: 0;
  width: 0;
`;
const LinkContainer = styled.div`
  flex: 1 1 0px;
`;
